import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">WhiteLabelDevs</div>
            <p className="footer-tagline">
              White-label development and cloud services partner for agencies. 
              We build, host, scale, and support your applications with confidence.
            </p>
            <div className="footer-company-info">
              <p className="company-name">VIDYADHAR GLOBAL AI INNOVATIONS PRIVATE LIMITED</p>
              <p className="company-cin">CIN: U62090UP2026PTC241378</p>
            </div>
          </div>
          
          <div className="footer-links">
            <div className="footer-section">
              <h4 className="footer-title">Quick Links</h4>
              <ul className="footer-menu">
                <li><button onClick={() => scrollToSection('services')}>Services</button></li>
                <li><button onClick={() => scrollToSection('pricing')}>Pricing</button></li>
                <li><button onClick={() => scrollToSection('process')}>Process</button></li>
                <li><button onClick={() => scrollToSection('contact')}>Contact</button></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4 className="footer-title">Contact</h4>
              <ul className="footer-contact">
                <li>
                  <Mail size={16} />
                  <span>contact@whitelabeldevs.com</span>
                </li>
                <li>
                  <Phone size={16} />
                  <span>+91 8766346052</span>
                </li>
                <li>
                  <MapPin size={16} />
                  <span>2 Maa Pitambara Complex, Dwarika Green Phase 2, Agra Bamroli Road, UP 282009</span>
                </li>
              </ul>
            </div>
          </div>
              <div className="footer-section footer-services">
                <h4 className="footer-title">Services</h4>
                <ul className="footer-menu">
                  <li>White-label Laravel Development</li>
                  <li>Custom Web App / CRM / SaaS</li>
                  <li>API Development &amp; Integration</li>
                  <li>Bug Fixing / Rescue Project</li>
                  <li>Performance &amp; Security</li>
                  <li>Managed Cloud Hosting</li>
                  <li>Monthly Partnership</li>
                </ul>
              </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            &copy; {currentYear} Vidyadhar Global AI Innovations Private Limited. All rights reserved. <Link to="/disclaimer" className="footer-disclaimer-link">See disclaimer for technology trademarks.</Link>
          </p>
          <div className="footer-legal">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-of-service">Terms of Service</Link>
            <Link to="/nda-template">NDA Template</Link>
            <Link to="/refund-policy">Refund Policy</Link>
            <Link to="/disclaimer">Disclaimer</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;